import {
  getFoodCleaningControlByInstanceId,
  getItemByInstanceId,
  getMaintenanceExamsByInstanceId,
  getPestsRevisionControlByInstanceId,
  getPestsRoundingControlByInstanceId,
  getThermometerVerificationByInstanceId,
} from "../service";
import { getFoodProductionControlByInstanceId } from "../service/foodManagementService/foodProductionService";
import { getFoodTemperatureControlByInstanceId } from "../service/foodManagementService/foodTemperatureService";
import { getProgramRevisionByInstanceId } from "../service/foodManagementService/programRevisionService";
import {
  ControlPointCategory,
  ControlPointReportCategory,
  FoodControlPoint,
  FoodControlPointInstanceDto,
  FoodManagementControls,
  FoodReport,
} from "../types/FoodManagementTypes";

export function categorizeFoodControlPoints(
  controls: FoodControlPointInstanceDto[],
) {
  return controls.reduce<
    Record<ControlPointCategory, FoodControlPointInstanceDto[]>
  >(
    (acc, item) => {
      const type = item.controlPoint?.type ?? "unknown";

      let category: ControlPointCategory = "Unknown Category";

      switch (type) {
        case FoodManagementControls.freezer:
        case FoodManagementControls.coldRoom:
        case FoodManagementControls.cooler:
        case FoodManagementControls.fishCooler:
          category = "Inventory Controls";
          break;
        case FoodManagementControls.cleaningDishwasher:
          category = "Dishwasher Controls";
          break;
        case FoodManagementControls.goodsReceipt:
          category = "Food Acceptance Controls";
          break;
        case FoodManagementControls.coolingFood:
        case FoodManagementControls.reheatingFood:
        case FoodManagementControls.heatingTreatment:
        case FoodManagementControls.heatRetetion:
        case FoodManagementControls.vegetablespHbeginning:
        case FoodManagementControls.vegetablespH48Hours:
        case FoodManagementControls.vegetablespHfinal:
        case FoodManagementControls.picklespH:
        case FoodManagementControls.sushiricepH:
        case FoodManagementControls.openbuffet:
        case FoodManagementControls.freezingfish:
          category = "Food Processing Controls";
          break;
        case FoodManagementControls.revisionOfControls:
        case FoodManagementControls.pestsRevision:
        case FoodManagementControls.pestsRouding:
        case FoodManagementControls.maintenanceExamination:
        case FoodManagementControls.thermometerVerification:
          category = "Yearly or Other Controls";
          break;
        default:
          category = "Unknown Category";
      }

      if (!acc[category]) {
        acc[category] = [];
      }

      acc[category].push(item);

      return acc;
    },
    {
      "Inventory Controls": [],
      "Dishwasher Controls": [],
      "Food Acceptance Controls": [],
      "Food Processing Controls": [],
      "Yearly or Other Controls": [],
      "Unknown Category": [],
    },
  );
}

export function checkInventory(type: string) {
  if (
    type === FoodManagementControls.coldRoom ||
    type === FoodManagementControls.cooler ||
    type === FoodManagementControls.freezer ||
    type === FoodManagementControls.fishCooler
  ) {
    return true;
  }
  return false;
}

export function isDisplayNameTypes(type: string) {
  if (
    type === FoodManagementControls.cleaningDishwasher ||
    type === FoodManagementControls.coldRoom ||
    type === FoodManagementControls.cooler ||
    type === FoodManagementControls.freezer ||
    type === FoodManagementControls.fishCooler
  ) {
    return true;
  }
  return false;
}

export function categorizeFoodReports(
  reports: FoodReport[],
): Record<ControlPointReportCategory, FoodReport[]> {
  return reports.reduce<Record<ControlPointReportCategory, FoodReport[]>>(
    (acc, report) => {
      const type = report.type;

      let category: ControlPointReportCategory = "Unknown Category";

      switch (type) {
        case FoodManagementControls.freezer:
        case FoodManagementControls.coldRoom:
        case FoodManagementControls.cooler:
        case FoodManagementControls.fishCooler:
          category = "Inventory Controls";
          break;
        case FoodManagementControls.goodsReceipt:
          category = "Food Acceptance Controls";
          break;
        case FoodManagementControls.coolingFood:
        case FoodManagementControls.reheatingFood:
        case FoodManagementControls.heatingTreatment:
        case FoodManagementControls.heatRetetion:
        case FoodManagementControls.vegetablespHbeginning:
        case FoodManagementControls.vegetablespH48Hours:
        case FoodManagementControls.vegetablespHfinal:
        case FoodManagementControls.picklespH:
        case FoodManagementControls.sushiricepH:
        case FoodManagementControls.openbuffet:
        case FoodManagementControls.freezingfish:
          category = "Food Processing Controls";
          break;
        case FoodManagementControls.cleaningDishwasher:
          category = "Dishwasher Controls";
          break;
        case FoodManagementControls.cleaningFloor:
        case FoodManagementControls.cleaningHood:
          category = "Cleaning Controls";
          break;
        case FoodManagementControls.revisionOfControls:
        case FoodManagementControls.pestsRevision:
        case FoodManagementControls.pestsRouding:
        case FoodManagementControls.maintenanceExamination:
        case FoodManagementControls.thermometerVerification:
          category = "Yearly or Other Controls";
          break;
        default:
          category = "Unknown Category";
      }

      if (!acc[category]) {
        acc[category] = [];
      }

      acc[category].push(report);

      return acc;
    },
    {
      "Inventory Controls": [],
      "Food Acceptance Controls": [],
      "Food Processing Controls": [],
      "Cleaning Controls": [],
      "Dishwasher Controls": [],
      "Yearly or Other Controls": [],
      "Unknown Category": [],
    },
  );
}

export function getFoodControlDetail(
  type: FoodManagementControls,
  instanceId: string,
) {
  switch (type) {
    case FoodManagementControls.freezer:
    case FoodManagementControls.coldRoom:
    case FoodManagementControls.cooler:
    case FoodManagementControls.fishCooler:
      return getFoodTemperatureControlByInstanceId(instanceId);
    case FoodManagementControls.goodsReceipt:
      return getItemByInstanceId(instanceId);
    case FoodManagementControls.coolingFood:
    case FoodManagementControls.reheatingFood:
    case FoodManagementControls.heatingTreatment:
    case FoodManagementControls.heatRetetion:
      return getFoodProductionControlByInstanceId(instanceId);
    case FoodManagementControls.cleaningDishwasher:
    case FoodManagementControls.cleaningFloor:
    case FoodManagementControls.cleaningHood:
      return getFoodCleaningControlByInstanceId(instanceId);
    case FoodManagementControls.pestsRevision:
      return getPestsRevisionControlByInstanceId(instanceId);
    case FoodManagementControls.pestsRouding:
      return getPestsRoundingControlByInstanceId(instanceId);
    case FoodManagementControls.revisionOfControls:
      return getProgramRevisionByInstanceId(instanceId);
    case FoodManagementControls.maintenanceExamination:
      return getMaintenanceExamsByInstanceId(instanceId);
    case FoodManagementControls.thermometerVerification:
      return getThermometerVerificationByInstanceId(instanceId);
    default:
      return;
  }
}

export function groupInstancesByControlPoint(
  instances: FoodControlPointInstanceDto[],
): Record<FoodManagementControls, FoodControlPointInstanceDto[]> {
  return instances.reduce<Record<string, FoodControlPointInstanceDto[]>>(
    (acc, instance) => {
      const controlPointType = instance.controlPoint?.type ?? "unknown";
      if (!acc[controlPointType]) {
        acc[controlPointType] = [];
      }
      acc[controlPointType].push(instance);
      return acc;
    },
    {},
  );
}

export const getCategoryName = (point: FoodControlPoint) => {
  const type = point?.type;
  let category = "";
  switch (type) {
    case FoodManagementControls.freezer:
    case FoodManagementControls.coldRoom:
    case FoodManagementControls.cooler:
    case FoodManagementControls.fishCooler:
      category = "Inventory Controls";
      break;
    case FoodManagementControls.goodsReceipt:
      category = "Food Acceptance Controls";
      break;
    case FoodManagementControls.coolingFood:
    case FoodManagementControls.reheatingFood:
    case FoodManagementControls.heatingTreatment:
    case FoodManagementControls.heatRetetion:
    case FoodManagementControls.vegetablespHbeginning:
    case FoodManagementControls.vegetablespH48Hours:
    case FoodManagementControls.vegetablespHfinal:
    case FoodManagementControls.picklespH:
    case FoodManagementControls.sushiricepH:
    case FoodManagementControls.openbuffet:
    case FoodManagementControls.freezingfish:
      category = "Food Processing Controls";
      break;
    case FoodManagementControls.cleaningDishwasher:
    case FoodManagementControls.cleaningFloor:
    case FoodManagementControls.cleaningHood:
      category = "Cleaning Controls";
      break;
    case FoodManagementControls.revisionOfControls:
    case FoodManagementControls.pestsRevision:
    case FoodManagementControls.pestsRouding:
    case FoodManagementControls.maintenanceExamination:
    case FoodManagementControls.thermometerVerification:
      category = "Yearly or Other Controls";
      break;
    default:
      category = "Unknown Category";
  }
  return category;
};
